import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from "@azure/msal-angular";

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'signin',
  },
  {
    canActivateChild: [MsalGuard],
    path: 'home',
    loadChildren: () =>
      import('./navigation-panel/navigation-panel.module').then(
        (m) => m.NavigationPanelModule
      ),
  },

  {
    path: 'error-pages',
    loadChildren: () =>
      import('./error-pages/error-pages.module').then(
        (m) => m.ErrorPagesModule
      ),
  },
  // {
  //   path: '**',
  //   redirectTo: 'error-pages/error-404',
  //   pathMatch: 'full',
  // },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
